// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.node {
    border-radius: 4px;
    border: 1px solid #fff;
    background-color: #fff;
    box-sizing: border-box;
}

.react-flow__resize-control.handle {
    width: 7px;
    height: 7px;
    border-radius: 100%;
    background-color: transparent;
    border-color: transparent;
}

.react-flow__node {
    -webkit-user-select: auto;
            user-select: auto;
}

.circle-button {
    width: 30px;
    height: 30px;
    border-radius: 15px;
    background-color: white;
    /* 默认背景色 */
    text-align: center;
    line-height: 50px;
    /* 垂直居中 */
    cursor: pointer;
    border: 1px solid gray;
    /* 边框 */
    transition: background-color 0.3s ease, color 0.3s ease;
    /* 添加过渡效果 */
    align-items: center;
    justify-content: center;
    display: flex;
}

.circle-button:hover {
    background-color: #f1f1f1;
    /* 悬停时的背景色 */
}

.circle-button-borderless {
    width: 28px;
    height: 28px;
    border-radius: 14px;
    /* background-color: white; */
    /* 默认背景色 */
    /* text-align: center; */
    /* line-height: 50px; */
    /* 垂直居中 */
    cursor: pointer;
    /* 边框 */
    transition: background-color 0.3s ease, color 0.3s ease;
    /* 添加过渡效果 */
    align-items: center;
    justify-content: center;
    display: flex;
}

.circle-button-borderless:hover {
    opacity: 0.5;
    /* 悬停时的背景色 */
}

.hoverStand {
    cursor: pointer;
    padding: 8px 6px;
    margin: 0;
    display: flex;
    align-items: center;
    font-size: 14px;
    border-radius: 3px;
    -webkit-user-select: none;
            user-select: none;
}

.hoverStand:hover {
    background-color: rgba(0, 0, 0, 0.1);
}

.hover_shadow:hover {
    opacity: 0.8;
    box-shadow: 0px 0px 8px #bbb;
}

.transparent-background {
    border-radius: 4px;
    /* background-color: rgba(0, 0, 0, 0); */
    /* 半透明黑色背景 */
    transition: background-color 0.3s ease;
    /* 添加过渡效果 */
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.transparent-background:hover {
    /* background-color: rgba(0, 0, 0, 0.1); */
    opacity: 0.8;
    /* 鼠标悬停时变成更加半透明的背景色 */
}

.react-flow__node.highlight {
    background-color: #ff0072;
    color: white;
  }`, "",{"version":3,"sources":["webpack://./src/components/flow/node.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;IACI,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,6BAA6B;IAC7B,yBAAyB;AAC7B;;AAEA;IACI,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,kBAAkB;IAClB,iBAAiB;IACjB,SAAS;IACT,eAAe;IACf,sBAAsB;IACtB,OAAO;IACP,uDAAuD;IACvD,WAAW;IACX,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,6BAA6B;IAC7B,UAAU;IACV,wBAAwB;IACxB,uBAAuB;IACvB,SAAS;IACT,eAAe;IACf,OAAO;IACP,uDAAuD;IACvD,WAAW;IACX,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,YAAY;IACZ,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,wCAAwC;IACxC,YAAY;IACZ,sCAAsC;IACtC,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,0CAA0C;IAC1C,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,YAAY;EACd","sourcesContent":[".node {\n    border-radius: 4px;\n    border: 1px solid #fff;\n    background-color: #fff;\n    box-sizing: border-box;\n}\n\n.react-flow__resize-control.handle {\n    width: 7px;\n    height: 7px;\n    border-radius: 100%;\n    background-color: transparent;\n    border-color: transparent;\n}\n\n.react-flow__node {\n    user-select: auto;\n}\n\n.circle-button {\n    width: 30px;\n    height: 30px;\n    border-radius: 15px;\n    background-color: white;\n    /* 默认背景色 */\n    text-align: center;\n    line-height: 50px;\n    /* 垂直居中 */\n    cursor: pointer;\n    border: 1px solid gray;\n    /* 边框 */\n    transition: background-color 0.3s ease, color 0.3s ease;\n    /* 添加过渡效果 */\n    align-items: center;\n    justify-content: center;\n    display: flex;\n}\n\n.circle-button:hover {\n    background-color: #f1f1f1;\n    /* 悬停时的背景色 */\n}\n\n.circle-button-borderless {\n    width: 28px;\n    height: 28px;\n    border-radius: 14px;\n    /* background-color: white; */\n    /* 默认背景色 */\n    /* text-align: center; */\n    /* line-height: 50px; */\n    /* 垂直居中 */\n    cursor: pointer;\n    /* 边框 */\n    transition: background-color 0.3s ease, color 0.3s ease;\n    /* 添加过渡效果 */\n    align-items: center;\n    justify-content: center;\n    display: flex;\n}\n\n.circle-button-borderless:hover {\n    opacity: 0.5;\n    /* 悬停时的背景色 */\n}\n\n.hoverStand {\n    cursor: pointer;\n    padding: 8px 6px;\n    margin: 0;\n    display: flex;\n    align-items: center;\n    font-size: 14px;\n    border-radius: 3px;\n    user-select: none;\n}\n\n.hoverStand:hover {\n    background-color: rgba(0, 0, 0, 0.1);\n}\n\n.hover_shadow:hover {\n    opacity: 0.8;\n    box-shadow: 0px 0px 8px #bbb;\n}\n\n.transparent-background {\n    border-radius: 4px;\n    /* background-color: rgba(0, 0, 0, 0); */\n    /* 半透明黑色背景 */\n    transition: background-color 0.3s ease;\n    /* 添加过渡效果 */\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n}\n\n.transparent-background:hover {\n    /* background-color: rgba(0, 0, 0, 0.1); */\n    opacity: 0.8;\n    /* 鼠标悬停时变成更加半透明的背景色 */\n}\n\n.react-flow__node.highlight {\n    background-color: #ff0072;\n    color: white;\n  }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
